import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

/** The one cache for the panel; the router uses it too, to fetch a section's data ahead. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 401 means the session ended: go to login instead of retrying.
      retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
      refetchOnWindowFocus: true,
    },
  },
});
